// JS - (c) mpunkt GmbH
import $ from 'jquery';

require('../vendor/modernizr.touch.js');
require('../vendor/cement.min');
require('../vendor/slick.min.js');
require('./contact_map');

// jQuery Definitionen
window.jQuery = $;
window.$ = $;

// Helper
import './helper';
import JsPath from './path';

/**
 * Ajax-Formulare
 */
(function($) {
  $.fn.mpAjaxForm = function(conf) {
    var defaults = {};
    var config = $.extend(defaults, conf);
    $(this).find('form:first').submit(function() {

      var form = $(this);
      var ajaxform = $(form).find('input[name=ajaxform]').val();

      // Formular per Ajax senden?
      if (ajaxform > 0 && $(form).attr('enctype') !== 'multipart/form-data') {
        $(form).find('input[name=ajaxform]').attr('name', 'ajax_form');
        var form_data = $(this).find('input:not([type=checkbox],[type=checkbox],[type=submit],[type=image],[type=reset]), input[type=checkbox]:checked, input[type=radio]:checked, textarea, select').serialize();

        $.ajax({
          url: form.attr('action'),
          type: form.attr('method'),
          data: form_data,
          success: function(html) {
            $('#c' + ajaxform).replaceWith(html);
            $('#c' + ajaxform).mpAjaxForm(conf);

            var formtop = $('#c' + ajaxform).offset().top;
            if ($(window).scrollTop() > formtop) {
              $('html,body').animate({scrollTop: formtop}, 500);
            }
          },
        });
        return false;
      }
    });
  };
})(jQuery);

// Ajax-Formulare (NonTypo-Forms)
(function($) {
  $.fn.ajaxForm = function(conf) {
    var defaults = {};
    var config = $.extend(defaults, conf);
    $(this).on('submit', function() {
      var form = $(this);

      form.addClass('process');
      // Formular per Ajax senden?
      if (form.data('action') && $(form).attr('enctype') !== 'multipart/form-data') {
        var form_data = $(this).find('input:not([type=checkbox],[type=submit],[type=image],[type=reset]), input[type=checkbox]:checked, input[type=radio]:checked, textarea, select').serialize();
        $.ajax({
          url: form.data('action'),
          type: form.attr('method'),
          data: form_data,
          success: function(html) {
            form.removeClass('process');
            $(form).replaceWith(html);
          },
        });
        return false;
      }
    });
    return this;
  };
})(jQuery);

/**
 * Scripts asynchron laden
 */
(function($) {
  $.extend({
    loadScript: function(source, callback, cache) {
      var c = (typeof cache == 'undefined' ? true : cache);
      (function(d, t) {
        var g = d.createElement(t),
            s = d.getElementsByTagName(t)[0];
        g.src = source + (c == false ? '?_=' + new Date().getTime() : '');
        g.onload = function() {
          callback();
        };
        s.parentNode.insertBefore(g, s);
      }(document, 'script'));
    },
  });
})(jQuery);

/**
 * ajaxDialog
 */
(function($) {
  $.extend({
    ajaxDialog: function(url) {
      var self = $(this);
      var overlay = $('.overlay');

      self.show = function() {
        // Wenn Dialog schon vorhanden, dann nicht mehr schließen
        if (overlay.length === 0) {
          $('body').append('<div class="overlay"><div class="overlay-container"></div></div>').css('overflow', 'hidden');
          $('.overlay').show();
          $('.overlay-close').click(function() {
            self.close();
          });
        }

        $('embed, object').css('visibility', 'hidden');

        self.load();
      };

      self.load = function() {
        $.get(url, {}, function(response) {
          $('.overlay-container').html(response);
          $('.overlay-close').click(function() {
            self.close();
          });
        });
      };

      self.close = function() {
        overlay.remove();
        $('embed, object').css('visibility', 'visible');
        $('body').css('overflow', 'auto');
      };

      if (url === 'close') {
        if (overlay.length > 0) {
          self.close();
        }
        return;
      }

      self.show();

      // ESC Dialog schliessen
      $(document).off('keyup').on('keyup', function(e) {
        if (e.keyCode === 27) {
          self.close();
        }
      });
    },
  });
})(jQuery);

/**
 * Video/Iframe skalieren wie background-size:cover
 *
 * @param container - Größe, an die das Video angepasst wird
 * @param video - Video-Element, welches skaliert wird
 */
window.resizeBoxVideo = function(container, video) {
  var vid = video;
  vid.removeAttr('style');
  var vidwidth = Math.ceil(vid.outerWidth());
  var vidheight = Math.ceil(vid.outerHeight());
  var vidratio = vidwidth / vidheight;

  var box = container;
  var boxwidth = Math.ceil(box.outerWidth());
  var boxheight = Math.ceil(box.outerHeight());
  var boxratio = boxwidth / boxheight;

  var vidnewwidth = 0;
  var vidnewheight = 0;
  var ratio = 0;
  var ratiowidth = 0;
  var ratioheight = 0;

  ratiowidth = boxwidth / vidwidth;
  ratioheight = boxheight / vidheight;

  if (ratiowidth > ratioheight) {
    ratio = ratiowidth;
  } else {
    ratio = ratioheight;
  }

  vidnewwidth = Math.ceil(vidwidth * ratio);
  vidnewheight = Math.ceil(vidheight * ratio);

  // Debug
  /*console.log('===============================');
   console.log('ratiowidth:     '+ratiowidth);
   console.log('ratioheight:    '+ratioheight);
   console.log('-------------------------------');
   console.log('vidnewwidth:    '+vidnewwidth);
   console.log('vidnewheight:   '+vidnewheight);
   console.log('-------------------------------');
   console.log('vidwidth:       '+vidwidth);
   console.log('vidheight:      '+vidheight);
   console.log('vidratio:       '+vidratio);
   console.log('-------------------------------');
   console.log('boxwidth:       '+boxwidth);
   console.log('boxheight:      '+boxheight);
   console.log('boxratio:       '+boxratio);
   console.log('===============================');*/

  vid.css({
    'width': vidnewwidth + 'px',
    'height': vidnewheight + 'px',
  });
};

/**
 * Mindesthöhe für das Hero-Element - damit es nicht zu schmal in der Höhe wird
 */
window.headerwrapMinfullscreen = function() {
  var layoutHasFullscreen = $('#layout.fullscreen').length;
  var timeLineExists = $('#timeline').length;

  if (layoutHasFullscreen || timeLineExists) {
    var minheight = $(window).height();

    var bodyHasClass = $('body').hasClass('start');
    var heroHasNoticeScrollLayoutClass = $('#hero-scroll-notice').length && $('#hero-scroll-notice').hasClass('hero-scroll-notice-layout-1');

    var fullheight = bodyHasClass || heroHasNoticeScrollLayoutClass;

    if (!fullheight) {
      minheight = minheight / 100 * 80;
    }

    if ($(window).width() >= 1024 && minheight < 768) {
      minheight = 768;
    }

    if (!timeLineExists) {
      $('#header-wrap,#hero,#hero > .content-limiter').css('min-height', minheight);
    } else {
      $('#timeline > .timeline-for-above').css('min-height', minheight);
    }
  }
};

/**
 * Wechsel-Funktion für News-Kategorien
 */
let newsCategoryList;
let newsItemList;
let newsCategorySelect;
let newsShowNumbers = 6;

window.newsToggleInit = function() {
  newsCategoryList = $('#category-wrap').find('.category-item');
  newsItemList = $('#news-wrap .news-item');
  newsCategorySelect = $('#category-select');

  newsCategoryList.on('click', function() {
    newsToggleFilter($(this).data('uid'));
  });
  newsCategoryList.filter('.active').trigger('click');

  newsCategorySelect.on('change', function() {
    newsToggleFilter($(this).val());
  });

  $('#news-load-more').on('click', newsShowMore);
};

window.newsToggleFilter = function(catId) {
  newsCategoryList.removeClass('active');
  newsCategoryList.filter('[data-uid=' + catId + ']').addClass('active');

  // Alle Kacheln ausblenden
  newsItemList.hide();

  newsShowMore();
};

window.newsShowMore = function() {
  const catId = newsCategoryList.filter('.active').data('uid');

  // Die ersten/nächsten (x) Kacheln mit entsprechendem Filter einblenden
  newsItemList.filter('.cat-' + catId + ':hidden').each(function(i) {
    if (i < newsShowNumbers) {
      $(this).show();
    }
  });

  // Anschließend nochmal prüfen, ob noch weitere Kacheln verfügbar sind
  if (newsItemList.filter('.cat-' + catId + ':hidden').length > 0) {
    $('#news-load-more').show();
  } else {
    $('#news-load-more').hide();
  }
};

/**
 * Select manipulieren
 */
window.awesomeInputs = function() {
  $('.awesome-select').each(function() {
    var $select = $(this);
    var selectvaluetxt = $select.find(':selected').text();
    if (!$select.next('.awesome-select-output').length) {
      /** Aufbau Fake-Select **/
          // Alle Optionen in ein Array packen
      var optionsArray = [];
      $select.find('option').each(function() {
        var option = $(this);
        optionsArray.push({
          id: option.attr('value'),
          name: option.text(),
        });
      });
      // Aufbau des Fake-Selects
      $select.after('<div class="awesome-select-output">' +
          '<div class="selected">' + selectvaluetxt + '</div>' +
          '<div class="options"></div>' +
          '</div>');
      // Optionen in Fake-Select
      $.each(optionsArray, function(key, value) {
        $select.next('.awesome-select-output').find('.options').append('<div data-value="' + value['id'] + '">' + value['name'] + '</div>');
      });

      var $newselect = $select.next('.awesome-select-output');
      // Aktuelle Option in Fake-Select mit Klasse versehen
      $newselect.find('.options').children('[data-value=' + $select.val() + ']').addClass('on');

      /** Click-Funktionen  **/
      // Öffnen des Dropdowns
      $newselect.find('.selected').on('click', function() {
        $newselect.toggleClass('open');
      });
      // Wert des Dropdowns austauschen
      $newselect.find('.options').children().on('click', function() {
        var val = $(this).data('value');
        $select.val(val).trigger('change'); // Wert auf ausgeblendetes Select austauschen
        $newselect.removeClass('open').find('.selected').text($select.find(':selected').text()); // Dropdown schließen und Ausgabe der ausgewählten Option
        // Klassen für aktuelles Element in Fakedropdown
        $newselect.find('.options').children().removeClass('on');
        $(this).addClass('on');
      });

      awesomeInputsResponsive();
    }
  });
};

/**
 * Mobile custom Selects ausblenden
 */
window.awesomeInputsResponsive = function() {
  if ($(window).width() >= 1024 && $('html').hasClass('no-touchevents')) {
    $('.awesome-select-output').show();
    $('.awesome-select').hide();
  } else {
    $('.awesome-select-output').hide();
    $('.awesome-select').show();
  }
};

/**
 * Bei Stellenangebote Tabelle klappbare Elemente
 */
window.expandTable = function() {
  $('.fake-tablerow.more').each(function() {
    var trigger = $(this);
    if (!trigger.hasClass('init')) {
      var next = $(this).next('.fake-tablerow-more');
      next.append('<div class="close"></div>');

      /** Click-Funktion **/
      trigger.addClass('init').on('click', function() {
        // Hash anhängen beim öffnen = Damit bleibt beim reload das item offen
        if ($(this).data('hash')) {
          var hash = $(this).data('hash');
          var url = window.location.href;
          var tmp = url.split('#')[0];
          var newurl = tmp + '#' + hash;
          history.pushState({}, '', newurl);
        }
        setTimeout(function() {
          trigger.siblings('.fake-tablerow.more').slideDown(250);
          trigger.siblings('.fake-tablerow.more').next('.fake-tablerow-more').slideUp(250);

          trigger.slideUp(250);
          next.slideDown(250);
        }, 10);

      });
      next.find('.close').on('click', function() {
        history.pushState('', document.title, window.location.pathname + window.location.search);
        setTimeout(function() {
          trigger.slideDown(250);
          next.slideUp(250);
        }, 10);
      });
    }
  });
};

/**
 * Stellenangebote Filter
 */
window.filterJobList = function() {
  $('.job-table').find('select').on('change', function() {
    var lang = $('html').attr('lang');
    var vals = [];

    let params = new URLSearchParams();

    $('.job-table').find('select').each(function() {
      var select = $(this);
      vals.push({
        name: select.attr('name'),
        val: select.val(),
      });

      let option = select.prop('selectedIndex');

      if (option) {
        option = select.prop('options')[option];
        option = $(option).attr('data-slug');

        params.set(getJobTranslations(select.attr('name'))[document.documentElement.lang], option);
      }
    });

    params = params.toString();

    let location = window.location.pathname;
    if (params) location += '?' + params;
    location += window.location.hash;

    window.history.pushState(null, '', location);

    $('.job-table').append('<div class="lds-ring-wrap"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>');

    $.ajax({
      type: 'GET',
      data: {
        vals: vals, LANG: lang, ajax: 1,
        file: document.location.pathname // Workaround for URL generation
      },
      url: MP_PATH + 'ajax/ajax.list_jobs.php',
      success: function(html) {
        setTimeout(function() {
          $('.job-table').parent().replaceWith(html).find('.lds-ring').remove();
        }, 100);
      },
    });
  });
};

/**
 * Stellenangebote Filter resetten
 */
window.resetFilterJobList = function() {
  $('.job-table').find('select').each(function() {
    var select = $(this);
    select.val(0);
  }).trigger('change');

  let location = window.location.pathname;
  location += window.location.hash;

  window.history.pushState(null, '', location);
};

/**
 * Stellenangebote Filter aus URL übernehmen
 */
window.applyJobFilters = function() {
  const params = new URLSearchParams(window.location.search);

  $('.job-table').find('select').each(function () {
    const param = params.get(getJobTranslations($(this).attr('name'))[document.documentElement.lang]);

    if (param) {
      const value = $(this).find('[data-slug="' + param + '"]').val();
      $(this).val(value);
    }
  }).trigger('change');

  filterJobList();
};

/**
 * Übersetzungen für Stellenangebote
 */
window.getJobTranslations = function(needle) {
  const translations = [
    { de: "stellen", en: "jobs" },
    { de: "arbeitsbereiche", en: "divisions" },
    { de: "standorte", en: "locations" }
  ];

  if (needle) {
    return translations.find(haystack => Object.values(haystack).includes(needle));
  } else {
    return translations;
  }
};

/**
 * Klappbox mit festem Aufbau
 * wrap mit zwei kinder. erstes kind ist trigger, zweites der Inhalt, der aufgeklappt wird
 *
 * @param trigger
 */
window.simpleFold = function(trigger) {
  trigger.on('click', function() {
    $(this).parent().toggleClass('open').children('*:last-child').stop().slideToggle(250);
  });
};

/**
 * Einsatzgebiete aufklappen
 */
window.showNextWorkfield = function(item, pid, langFlag, type) {
  $.ajax({
    type: 'GET',
    data: {pid: pid, type: type, langFlag: langFlag, ajax: 1},
    url: MP_PATH + 'ajax/ajax.show_subworkfield.php',
    success: function(html) {
      item.closest('.wf-section').nextAll('.wf-section').remove();
      item.closest('.wf-section').after(html);
      setTimeout(function() {
        $('html, body').animate({
          scrollTop: item.closest('.wf-section').next('.wf-section').offset().top,
        }, 400);
      }, 10);
    },
  });
};

/**
 * Kontaktkarte (Landingpage)
 * Akkordions
 */
window.companyLocationsAccordions = function() {
  var companyLocation = $('.company-location');

  if (companyLocation.length > 0) {
    companyLocation.each(function() {
      $(this).children('.company-location-header').on('click', function() {
        var companyLocationEle = $(this).closest('.company-location');

        // Toggle Akkordion
        companyLocationEle.toggleClass('active').children('.company-location-content').stop().slideToggle('fast');

        // Schließe alle anderen Akkordions
        companyLocationEle.siblings().removeClass('active').children('.company-location-content').stop().slideUp('fast');
      });
    });
  }
};

/**
 * Füge Produkt in Warenkorb hinzu
 * @param obj
 * @param productID
 * @returns {boolean}
 */
window.addToBasket = function(obj, productID) {
  var size;
  var existSizeField = false;
  var SizeField = $(obj).closest('div.prod-action').find('select');
  if (SizeField.length > 0) {
    existSizeField = true;
    var size = $(obj).closest('div.prod-action').find('select option:selected').val();
    if (!size) {
      $(obj).closest('div.prod-action').find('select').addClass('err');
      return false;
    } else {
      $(obj).closest('div.prod-action').find('select').removeClass('err');
    }
  }

  $('#adding-basket').toggleClass('open');
  $('#cart-check').show();

  $.ajax({
    url: MP_PATH + 'ajax/ajax.addBasket.php',
    type: 'get',
    data: {
      productID: productID,
      existSizeField: existSizeField,
      size: size,
    },
    dataType: 'json',
    success: function(res) {
      var countProducts = parseInt(res.countProducts);
      if (countProducts > 0) {
        $('#menu-service .basket-counter').show();
        $('#basket-num').html(countProducts);
      } else {
        $('.basket-content').remove();
      }

    },
  });
  return false;
};

/**
 * Content-Dialog anzeigen
 */
window.showContentDialog = function(id) {
  $('.dialog-content' + id).toggleClass('open');
};

/**
 * Prüfe RabattCode bei DriversClub
 * @param obj
 */
window.checkRabattCode = function(obj) {
  if ($(obj).val() !== '') {
    $.getJSON(MP_PATH + 'ajax/ajax.checkRabattCode.php', {code: $(obj).val()}, function(data) {
      if (data.valid === true) {
        $('#validCode').addClass('valid');
      } else {
        $('#validCode').removeClass('valid');
      }
    });
  }
};

/**
 * findGetParameter
 * @param parameterName
 * @returns {null}
 */
function findGetParameter(parameterName) {
  let result = null,
      tmp = [];
  location.search.substr(1).split('&').forEach(function(item) {
    tmp = item.split('=');
    if (tmp[0] === parameterName) {
      result = decodeURIComponent(tmp[1]);
    }
  });
  return result;
}

/**
 * window hashChange
 */
$(window).bind('hashchange', function(e) {
  e.preventDefault();
  if (location.hash !== '' && location.hash.length > 0) {
    $('html,body').animate({scrollTop: $(location.hash).offset().top}, 500);
  }
});

// 2FA
window.onInput2FA = function(event) {
  const input = event.target;
  input.style.setProperty('--_otp-digit', input.selectionStart);
};

/**
 * Doc ready
 */
$(document).ready(function() {

  // CSS-Klasse wechseln, wenn JS aktiviert ist (für Fallbacks)
  $('html:first').removeClass('no-js').addClass('js');

  // Zoombox asynchron laden und starten
  $.loadScript(JsPath + 'vendor/jquery-zoombox.min.js', function() {
    $('.zoombox').zoombox();
  });

  // Salvattore asynchron laden
  if ($('.sww-wrap').length) {
    $.loadScript(JsPath + 'vendor/salvattore.js', function() {
    });
  }

  // Bypass-Menu Button
  $('.csc-menu-bypass').click(function(e) {
    e.preventDefault();
    var wrap = $(this).closest('.csc-frame');
    var scrollheight = wrap.offset().top + wrap.height();
    $('html,body').animate({scrollTop: scrollheight}, 500);
  });

  $('.csc-mailform').mpAjaxForm();

  // Responsive Menu
  // Menu-Button resettet die Classes vom Menü und lässt das Menü öffnen und schließen
  $('#menu-button').on('click', function() {
    $('body').toggleClass('menu-open');
  });

  // Hauptmenü (Mobil)
  // Menü-Toggle, Submenü-Isolation, Automatisches Springen auf aktive Seite
  var mainMenu = $('#menu');

  // Zum nächsten Menü (Untermenü)
  mainMenu.on('click touchend', 'span.sub-open, u.sub-open', function(e) {
    if (e.target instanceof HTMLAnchorElement)
      return;

    e.preventDefault();

    var mainMenu = $('#menu');
    var forwEle = $(this);
    var firstLevel = forwEle.parents().length - mainMenu.parents().length === 3;

    mainMenu.addClass('sub-toggled');
    // Klasse ändern, um gleiches Element fürs zurückspringen zu verwenden
    // Elternelement aktiv setzen
    $(forwEle).addClass('sub-close').removeClass('sub-open').closest('li').addClass('sub-active');

    // Submenü isolieren und alle anderen schließen (nur erste Ebene)
    if (firstLevel) {
      $(mainMenu).find('> ul > li').not(forwEle).removeClass('sub-active');
    }
    $(forwEle).closest('li').addClass('sub-active');
  });

  //Zurück zum vorherigen Menü
  mainMenu.on('click touchend', 'span.sub-close, u.sub-close', function(e) {
    e.preventDefault();

    var backEle = $(this);
    var firstLevel = backEle.parents().length - mainMenu.parents().length === 3;

    // Klasse ändern, um gleiches Element fürs öffnen zu verwenden
    // Elternelement inaktiv setzen
    $(backEle).removeClass('sub-close').addClass('sub-open').closest('li').removeClass('sub-active');

    // Wenn kein Menü offen, dann alle Überpunkte wieder anzeigen (nur erste Ebene)
    if (firstLevel) {
      if ($(mainMenu).find('> li.submenu-close')) {
        mainMenu.removeClass('sub-toggled');
      }
    }
  });

  // Submenü als offen markieren
  var activeSub = mainMenu.find('> ul > li a.active');
  if (activeSub.length) {
    activeSub.closest('li.firstlevel').addClass('sub-active');
  }

  // Masonry
  $('.grid-masonry .csc-grid-col').cement({
    columns: 3,
    columnMinWidth: 320,
    horizontalGutter: 10,
    verticalGutter: 10,
  });
  /* Masonry Limiter */
  $('.grid-masonry').each(function() {
    var grid = $(this);
    if (grid.data('masonrylimiter')) {
      var gridHeightLimit = parseInt(grid.data('masonrylimiter'));
      var gridHeight = 0;

      var boxHeight = 0;
      var boxDistance = 10;

      var expandButton = '';
      if (grid.data('masonrylimitertext')) {
        expandButton = grid.data('masonrylimitertext');
      }

      grid.find('.csc-box').each(function() {
        var box = $(this);
        if (box.data('h')) {
          if (box.data('h') === 1) {
            boxHeight = box.outerHeight() + boxDistance;
            return false;
          } else if (box.data('h') === 2) {
            boxHeight = (box.outerHeight() / 2) + (boxDistance / 2);
            return false;
          }
        }
      });

      if (boxHeight !== 0) {
        gridHeight = boxHeight * gridHeightLimit;

        if (gridHeight !== 0) {
          if (grid.find('.csc-grid-row').outerHeight() > gridHeight) {
            grid.find('.csc-grid-row').css('height', gridHeight + 'px').after('<div class="expand-grid-row"><div class="expand-grid-button">' + expandButton + '</div></div>');
          }
        }
      }
    }
  });
  /* Masonry Limiter Button */
  $('.expand-grid-button').on('click', function(e) {
    e.preventDefault();
    $(this).parent().prev('.csc-grid-row').css('height', 'auto');
    $(this).parent().remove();
  });

  // News Archive
  var showNewsContainer = $('.show-news-container');
  showNewsContainer.next('.news-container').height('0');
  showNewsContainer.on('click', function(e) {
    e.preventDefault();
    $(this).next('.news-container').height('auto');
    $(this).remove();
  });

  /* Topthemen Startseite Header */
    if ($('#topic-wrap').length) {
      $('.topic-item').find('.topic-body').hide();
      $('.topic-item:first-of-type').toggleClass('open').find('.topic-body').slideToggle();
      $('.topic-header').on('click', function(e) {
        e.preventDefault();
        var item = $(this);
        item.siblings('.topic-body').slideToggle();
        item.parent('.topic-item').toggleClass('open');
        item.parent().siblings('.topic-item').find('.topic-body').slideUp();
        item.parent().siblings('.topic-item').removeClass('open');
      });
    }

  // Bei Seitenaufruf bis zur aktiven Menüebene alle Punkte aktiv setzen
  var activeEle = mainMenu.find('a.active');

  if (activeEle.length > 0) {
    // Hauptmenü auf toggled-state setzen, wenn Submenü
    if (activeEle.parents().length - mainMenu.parents().length !== 3) {
      mainMenu.addClass('sub-toggled');
    }

    // Überpunkte von öffnen-Action auf schließen-Action setzen
    activeEle.parents('ul').prev('.sub-open').addClass('sub-close').removeClass('sub-open').parent('li').addClass('sub-active');
  }

  // Alle Videos mit Autoplay starten
  $('video').each(function() {
    var video = $(this);
    var attr = video.attr('autoplay');
    // For some browsers, `attr` is undefined; for others, `attr` is false. Check for both.
    if (typeof attr !== typeof undefined && attr !== false) {
      video.get(0).play();
    }
  });

  /* Videos in Kacheln werden nur bei Mouseover abgespielt */
  var boxvideo = $('.box-inner').find('video');
  if (boxvideo.length) {
    // Alle Videos in Kacheln abspielen, während man drüber hovert
    boxvideo.closest('.box-inner').on('mouseenter', function() {
      $(this).find('video').addClass('hover').get(0).play();
    }).on('mouseleave', function() {
      $(this).find('video').removeClass('hover').get(0).pause();
    });
  }
  /* Um Iframes bei Hover abzuspielen muss die SRC ausgetauscht werden */
  var boxiframe = $('.box-inner').find('iframe');
  if (boxiframe.length) {
    var nowPlaying = 'none';
    // Alle Videos in Kacheln abspielen, während man drüber hovert
    boxiframe.closest('.box-inner').on('mouseenter', function() {
      nowPlaying = $(this).find('iframe').attr('src');
      $(this).find('iframe').attr('src', nowPlaying + '&autoplay=1');
    }).on('mouseleave', function() {
      $(this).find('iframe').attr('src', nowPlaying);
    });
  }
  // In Kacheln müssen die Videos skaliert werden, damit diese immer füllend sind
  // Video-Tags müssen auch bei document ready skaliert werden, da beim erneuten aufrufen diese nicht mehr bei window load ausgeführt werden
  if ($('.box-inner').find('video').length) {
    $('.box-inner').find('video').each(function() {
      $(this).on('canplay', function() {
        resizeBoxVideo($(this).closest('.box-inner'), $(this));
      });
    });
  }
  // Hero-Video auch skalieren
  if ($('#fullscreen-bg-video').length) {
    $('#fullscreen-bg-video').on('load', function() {
      resizeBoxVideo($(this).closest('#fullscreen-bg'), $(this));
    });
    $('#fullscreen-bg-video').on('canplay', function() {
      resizeBoxVideo($(this).closest('#fullscreen-bg'), $(this));
    });
  }

  headerwrapMinfullscreen();

  // Klappboxen in grauen Menüs
  simpleFold($('li.dd-li > *:first-child'));

  $('#contacttile > .inner > img').on('click', function() {
    $(this).closest('#contacttile').toggleClass('open');
  });
  /* Kontaktinfo in seitlichen Servicemenü */
  $('#contacttile li > span').on('click', function() {
    var ele = $(this);
    var elewrap = $(this).parent();

    var isActive = elewrap.hasClass('active');
    var isInactive = elewrap.hasClass('inactive');

    if (isActive) {
      elewrap.removeClass('active').siblings('li').removeClass('inactive');
      if (elewrap.hasClass('firstlvl')) {
        elewrap.children('ul').children().slideUp(200);
        elewrap.siblings().slideDown(200);
      } else {
        elewrap.children('ul').children().slideUp(200);
      }
      return;
    }

    if (isInactive) {
      elewrap.addClass('active').removeClass('inactive').siblings('li').addClass('inactive').removeClass('active');
      elewrap.children('ul').children().slideDown(200);
      elewrap.siblings().children('ul').children().slideUp(200);
      return;
    }

    elewrap.addClass('active').siblings('li').addClass('inactive');
    if (elewrap.hasClass('firstlvl')) {
      elewrap.children('ul').children().slideDown(200);
      elewrap.siblings().slideUp(200);
    } else {
      elewrap.children('ul').children().slideDown(200);
      elewrap.siblings().children('ul').children().slideUp(200);
    }
  });
  awesomeInputs();
  expandTable();
  filterJobList();
  // Aktuellen Job beim Seitenladen öffnen
  var job = window.location.hash.substring(1);
  if (job !== '' && job !== 'undefined') {
    if ($('.job-table').length) {
      $('.job-table').find('.fake-tablerow').each(function() {
        var ele = $(this);
        if (ele.data('hash') === job && ele.data('hash')) {
          ele.trigger('click');
          setTimeout(function() {
            $('html, body').animate({
              scrollTop: ele.offset().top,
            }, 500);
          }, 100);
        }
      });
    }
  }

  // Klappboxen
  // Klappboxen wrappen
  $(':not(.grid-accordion) + .grid-accordion, * > .grid-accordion:first-of-type').each(function() {
    $(this).nextUntil(':not(.grid-accordion)').addBack().wrapAll('<div class="grid-accordion-wrap" />');
  });
  // Inhalte der Klappboxen anzeigen
  $('.grid-accordion').children('header,.fake-header').click(function() {
    var ele = $(this);
    if (ele.find('a').length === 0) {
      if (ele.hasClass('active')) {
        ele.removeClass('active').nextAll('.csc-grid-row').slideUp(300).removeClass('open');
      } else {
        ele.closest('.grid-accordion-wrap').find('.grid-accordion').children('header,.fake-header').removeClass('active').nextAll('.csc-grid-row').slideUp(300).removeClass('open');
        ele.addClass('active').nextAll('.csc-grid-row').slideDown(300, function() {
          $(this).addClass('open');
        });
      }
    }
  });

  $('.video-trigger,#video-overlay-trigger').on('click', function(e) {
    e.preventDefault();
    const videoPath = $(this).data('path');
    const videoType = $(this).data('type');

    if (!$('body').hasClass('video-overlay-loading') && !$('#video-overlay').length) {

      $('body').addClass('video-overlay-loading');
      $.ajax({
        url: MP_PATH + 'ajax/ajax.videoOverlay.php',
        type: 'get',
        data: {videoPath: videoPath, videoType: videoType},
        success: function(html) {
          $('body').append(html);
          setTimeout(function() {
            $('body').addClass('show-video');
          }, 10);
        },
        complete: function(html) {
          $('body').removeClass('video-overlay-loading');
        },
      });

    }

  });

  /*$('#video-overlay-trigger').on('click', function (e) {
   e.preventDefault();
   $('body').addClass('show-video');

   var videoiframe = $('#video-overlay').find('iframe');
   if (videoiframe.length) {
   var nowPlaying = 'none';
   nowPlaying = videoiframe.data('src');
   videoiframe.attr('src', nowPlaying + '&autoplay=1');
   }
   var videohtml = $('#video-overlay').find('video');
   if (videohtml.length) {
   videohtml.addClass('hover').get(0).play();
   }
   });
   $('#video-overlay-close').on('click', function () {
   $('body').removeClass('show-video');

   var videoiframe = $('#video-overlay').find('iframe');
   if (videoiframe.length) {
   var nowPlaying = 'none';
   nowPlaying = videoiframe.data('src');
   videoiframe.attr('src', nowPlaying);
   }
   var videohtml = $('#video-overlay').find('video');
   if (videohtml.length) {
   videohtml.removeClass('hover').get(0).pause();
   }
   });*/

  // Back-Links
  $('.historyback').on('click', function(e) {
    e.preventDefault();
    window.history.back();
  });

  $('.grid-contentslider').find('.grid-col-0').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  });
  $('#prod-imgslider-wrap').slick({
    infinite: false,
    dots: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1240,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // Newskategorien
  newsToggleInit();

  /**
   * Timeline
   *
   * Zeitstrahl mittig zwischen oberen und unteren Inhalt
   * Full-Page
   * Zu finden bspw. auf Über uns > Geschichte
   */
  var timeline = $('#timeline');

  if (timeline.length > 0) {
    var timelineContentAbove = timeline.find('.timeline-for-above');
    var timelineContentBelow = timeline.find('.timeline-for-below > .timeline-for-below-inner');
    var timelinenav = timeline.find('.timeline-nav > .timeline-nav-inner');

    timeline.closest('#layout').addClass('timeline');

    // Inhalt über Timeline (Jahreszahlen)
    timelineContentAbove.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      asNavFor: timelinenav,
      ocusOnSelect: true,
      infinite: true,
      fade: true,
      swipe: false,
      speed: 250,
    });

    // Jahreszahlen der Timeline zwischen oberen und unteren Inhalt
    timelinenav.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      asNavFor: timelineContentBelow,
      arrows: true,
      dots: false,
      focusOnSelect: true,
      speed: 250,
      mobileFirst: true,
      infinite: false,
      swipe: false,
      responsive: [
        {
          breakpoint: 374,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 7,
          },
        },
      ],
    });

    // Inhalt unter Timeline (Jahreszahlen)
    timelineContentBelow.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: timelineContentAbove,
      arrows: false,
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      infinite: true,
      fade: true,
      swipe: false,
      speed: 250,
    });

    // Triggert sowohl Inhalt über Timeline (Jahreszahlen), als auch den darunter
    timelinenav.find('span[data-goto]').click(function() {
      var slideIndex = $(this).data('goto') - 1;

      timelineContentAbove.slick('slickGoTo', parseInt(slideIndex), false);
      timelineContentBelow.slick('slickGoTo', parseInt(slideIndex), false);
    });

    // Arrows der Timeline sollen auch den oberen bewegen
    timelinenav.find('.slick-next').on('click', function() {
      timelineContentAbove.slick('slickNext');
      timelineContentBelow.slick('slickNext');
    });
    timelinenav.find('.slick-prev').on('click', function() {
      timelineContentAbove.slick('slickPrev');
      timelineContentBelow.slick('slickPrev');
    });
  }

  // Ajaxforms (non-Typo3)
  $('.csc-ajaxform').ajaxForm();

  /**
   * Suche öffnen/schließen
   */
  $('#menupoint-search').on('click', function(e) {
    e.preventDefault();
    if ($('body').hasClass('search-open')) {
      $('body').removeClass('search-open');
      $('#menupoint-search').removeClass('active');
      $('#search-input').blur();
    } else {
      $('body').addClass('search-open');
      $('#menupoint-search').addClass('active');
      $('#search-input').focus();
    }
  });
  $('#search-close').on('click', function(e) {
    e.preventDefault();
    $('body').removeClass('search-open');
    $('#menupoint-search').removeClass('active');
    $('#search-input').blur();
  });

  /**
   * Footer Social Media Toggle (Transport/Airport)
   */
  $('#social-transport,#social-airport').children('div:first-child').on('click', function(e) {
    e.preventDefault();
    var ele = $(this);
    if (ele.parent().hasClass('on')) {
      ele.next().slideUp(150).parent().removeClass('on');
    } else {
      ele.parent().siblings().removeClass('on').children('div:last-child').slideUp(150);
      ele.next().slideDown(150).parent().addClass('on');
    }
  });
  $('a.hashlink').on('click', function(e) {
    e.preventDefault();
    var stateObj = {info: 'Bereich-Sektion'};
    history.pushState(stateObj, 'bereichSektion', $(this).attr('href'));
    location.reload();
  });

  $('#languages > .lang-item').on('click', function(e) {
    e.preventDefault();
    $(this).parent().toggleClass('on');
  });

  // Refresh Warenkorb
  $('#basket').submit(function() {
    var form_data = $(this).find('input:not([type=checkbox],[type=checkbox],[type=submit],[type=image],[type=reset]), input[type=checkbox]:checked, input[type=radio]:checked, textarea, select');
    $.ajax({
      url: MP_PATH + 'ajax/ajax.basket.php?ajax=1',
      type: 'post',
      data: form_data,
      success: function(html) {
        $('form#basket').html(html);
      },
    });
    return false;
  });

  $('#product-filter-trigger').on('click', function(e) {
    e.preventDefault();
    $(this).closest('#product-filter-wrap').toggleClass('open');
  });

  // Magazin Kacheln aus- / einblenden
  var magazinesWrap = $('.magazine-wrap');
  if (magazinesWrap.length > 0) {
    magazinesWrap.find('.magazine-show-more').children('.btn').on('click', function() {
      $(this).toggleClass('active').closest(magazinesWrap).find('.magazine-inner').toggleClass('more');
    });
  }

  // Open Flipbook PDF
  let pdfID = findGetParameter('pdf');
  if (pdfID) {
    $.ajaxDialog(MP_PATH + 'ajax/ajax.flipbook.php?pdfFileID=' + pdfID);
  }

  $('.csc-image-anchor-linktile, .csc-icon-anchor-item a').on('click', function(e) {
    e.preventDefault();
    const hash = $(this).prop('hash');

    $('html,body').animate({scrollTop: $(hash).offset().top}, 500);
  });

  // Akademie Formulare Teilnehmerdetails
  $('#member').on('change', function() {
    const val = $(this).val();
    const firstnamePlacer = $('#member-field-list').data('firstname');
    const lastnamePlacer = $('#member-field-list').data('lastname');
    const MultiLangMember = $('.member-details > div:first-child').data('member');

    // Abziehen
    $('#member-field-list > *').eq(val - 1).nextAll().remove();
    // Hinzufügen
    for (let i = 0; i < parseInt(val); i++) {
      if (!$('#member-field-list > *').eq(i).length) {
        // Reihe hinzufügen, falls noch nicht vorhanden
        const member = '<div class="member-details"><div>' + MultiLangMember + ' ' + (i + 1) + '</div><div class="form-group"><div class="form-field"><input type="text" name="academy[academyMember][' + (i + 1) + '][firstname]" value="" placeholder="' + firstnamePlacer +
            '"></div><div class="form-field"><input type="text" name="academy[academyMember][' + (i + 1) + '][lastname]" value="" placeholder="' + lastnamePlacer + '"></div></div></div>';
        $('#member-field-list').append(member);
      }
    }
  });

  $('.inputfile').each(function() {
    var $input = $(this),
        $label = $input.next('label'),
        labelVal = $label.html();

    $input.on('change', function(e) {
      var fileName = '';

      if (this.files && this.files.length > 1) {
        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
      } else if (e.target.value) {
        fileName = e.target.value.split('\\').pop();
      }

      if (fileName) {
        $label.find('span').html(fileName);
      } else {
        $label.html(labelVal);
      }
    });

    // Firefox bug fix
    $input.on('focus', function() {
      $input.addClass('has-focus');
    }).on('blur', function() {
      $input.removeClass('has-focus');
    });
  });
});

$(window).on('load', function() {
  // Grid-Element Bereich-Sektion
  // Im Menü verlinkte Bereiche können angepasste Hashurls haben, müssen aber weiter auf die ID des Containers verlinkbar sein
  if (location.hash !== '') {
    var hash = window.location.hash.substring(1);
    if ($('#' + hash).length) { // Verlinkung direkt zum Element via ID
      // URL manipulieren, wenn data attribut hinterlegt ist
      setTimeout(function() {
        $('html, body').animate({
          scrollTop: $('#' + hash).offset().top,
        }, 0);
      }, 10);

      var attr = $('#' + hash).data('hashlink');
      if (typeof attr !== typeof undefined && attr !== false) {
        var stateObj = {info: 'Bereich-Sektion'};
        history.pushState(stateObj, 'bereichSektion', window.location.href.split('#')[0] + '#' + attr);
      }
    } else if ($('[data-hashlink="' + hash + '"]').length > 0) {
      // Zum Element scrollen
      setTimeout(function() {
        $('html, body').animate({
          scrollTop: $('[data-hashlink="' + hash + '"]').offset().top,
        }, 0);
      }, 10);
    }
  }

  $('body').addClass('winload');
  // In Kacheln müssen die Videos skaliert werden, damit diese immer füllend sind
  if ($('.box-inner').find('video').length) {
    $('.box-inner').find('video').each(function() {
      $(this).on('canplay', function() {
        resizeBoxVideo($(this).closest('.box-inner'), $(this));
      });
    });
  }
  if ($('.box-inner').find('iframe').length) {
    $('.box-inner').find('iframe').each(function() {
      resizeBoxVideo($(this).closest('.box-inner'), $(this));
    });
  }
  // Hero-Video auch skalieren
  if ($('#fullscreen-bg-video').length) {
    $('#fullscreen-bg-video').on('load', function() {
      resizeBoxVideo($(this).closest('#fullscreen-bg'), $(this));
    });
    $('#fullscreen-bg-video').on('canplay', function() {
      resizeBoxVideo($(this).closest('#fullscreen-bg'), $(this));
    });
  }

  // Hero Video Fadeout
  const heroVideo = $('#fullscreen-bg-video');
  const videoFadeOut = heroVideo.data('fadeout') * 1000;
  if (videoFadeOut > 0) {
    setTimeout(function() {
      heroVideo.fadeOut(300);
    }, videoFadeOut);
  }

  if ($('.csc-imageslider').length) {
    $('.csc-imageslider').each(function() {
      const iSlider = $(this);
      const itemsDesktop = parseInt(iSlider.data('slideritems'));
      const itemsTablet = itemsDesktop > 3 ? 3 : itemsDesktop;
      const itemsMobile = 1;

      iSlider.slick({
        infinite: false,
        dots: false,
        speed: 300,
        autoplay: false,
        adaptiveHeight: true,
        slidesToShow: itemsDesktop,
        slidesToScroll: itemsDesktop,
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: itemsTablet,
              slidesToScroll: itemsTablet,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: itemsMobile,
              slidesToScroll: itemsMobile,
            },
          },
        ],
      });
    });
  }
});

$(window).on('resize', function() {
  // In Kacheln müssen die Videos skaliert werden, damit diese immer füllend sind
  if ($('.box-inner').find('video').length) {
    $('.box-inner').find('video').each(function() {
      resizeBoxVideo($(this).closest('.box-inner'), $(this));
    });
  }
  if ($('.box-inner').find('iframe').length) {
    $('.box-inner').find('iframe').each(function() {
      resizeBoxVideo($(this).closest('.box-inner'), $(this));
    });
  }
  // Hero-Video auch skalieren
  if ($('#fullscreen-bg-video').length) {
    resizeBoxVideo($('#fullscreen-bg-video').closest('#fullscreen-bg'), $('#fullscreen-bg-video'));
  }

  headerwrapMinfullscreen();

  awesomeInputsResponsive();
});